import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ReporteGerenteGeneralComponent from "../../../components/comisionesMembresia/reporteGerenteGeneral/ReporteGerenteGeneral";
import {
  ReporteGerenteGeneralStore,
  reporteGerenteGeneralStore
} from "./ReporteGerenteGeneral.store";
import {
  ReporteGerenteGeneralDispatcher,
  reporteGerenteGeneralDispatcher
} from "./ReporteGerenteGeneral.dispatcher";
import Layout from "../../../components/layout";

interface Props
  extends ReporteGerenteGeneralStore,
    ReporteGerenteGeneralDispatcher {}
interface State {}

@Router()
@ReduxConnect(reporteGerenteGeneralStore, reporteGerenteGeneralDispatcher)
export default class ReporteGerenteGeneralContainer extends Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Gestión de incidencias - Membresías" />
          <ReporteGerenteGeneralComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
